import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import first from "../../Assets/Projects/first.png";
import bot from "../../Assets/Projects/bot.png";
import festival from "../../Assets/Projects/festival.jpg";
import shadow from "../../Assets/Projects/shadow.jpeg";
import { Box, Button, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { CgLaptop } from "react-icons/cg";

function Projects() {
  const [input, setInput] = useState({
    WifiName: "",
    WifiPassword: "",
    Latitud: 0,
    Longitud: 0,
    NombreContacto: "",
    ApellidoContacto: "",
    TelefonoContacto: "",
  });

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Mis <strong className="purple">Trabajos </strong>
        </h1>
        <p style={{ color: "white" }}>
          Algunos proyectos que he estado desarrollando
        </p>
        <p style={{ color: "white" }}>
          Escribime para compartirte cualquiera de estos proyectos!
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={festival}
              isBlog={false}
              title="TicketHunter"
              description="Este proyecto se basa en el monitoreo de múltiples fuentes de venta de entradas en línea, recopilando y estructurando datos 
                           relevantes para construir un motor de búsqueda inteligente de eventos. Esta solución permite 
                           detectar tendencias de precios, 
                           comparar opciones y anticipar la demanda de entradas para espectáculos populares."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shadow}
              isBlog={false}
              title="ShadowWorker"
              description="Este proyecto tiene 3 principales funcionalidades:
              \n1- Monitorea periódicamente el uso de memoria RAM del sistema operativo (Windows o Linux), y lanza un evento si el uso de RAM excede un umbral definido.
              \n2- Configura un cliente HTTP resiliente utilizando políticas de tolerancia a fallos como Retry,CircuitBreak,Timeout y Fallback con POLLY
              \n3- Recopilación de metricas con PROMETHEUS y su posterior visualización con GRAFANA"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bot}
              isBlog={false}
              title="TeleKabot"
              description="Bot de Telegram con distintas funcionalidades como devolucion de imagenes obtenidas de una Api,resumenes de texto y conversor de texto a mensaje de voz!"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={first}
              isBlog={false}
              title="Essentials Skills"
              description="Proyecto base con ejercicios que implementan LINQ y una simulacion de multiples procesos de pago utilizando tareas asincronas y distintos tipos de colecciones"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
